import React from 'react';
import { Modal, Row } from 'react-bootstrap';
import PortletBody from '../../../app/components/portlet/PortletBody';
import { displayError } from '../CampaignsUtils';
import styled from 'styled-components';

const JobboardErrorModal = ({ show, onHide, details }) => {
  return (
    <Modal
      show={show}
      centered
      onHide={onHide}
      size={'lg'}
      className="bg-black bg-opacity-75"
    >
      <Modal.Header
        title="Call Us"
        closeButton
        className="border-bottom-0 pb-0 align-items-baseline me-3 "
      >
        <div>
          <Modal.Title
            as="h4"
            className="flex-grow-1 px-3 pt-3 cursor-pointer flex-center fs-3 mb"
          >
            Error Details
          </Modal.Title>
        </div>
      </Modal.Header>

      <Modal.Body className="d-flex  flex-column bg-body rounded ">
      <PortletBody className="p-0 w-100">
                <PortletBody className={'p-3 w-100'}>
                  <Row>
                    <Styleddiv className="col-12 col-md-12">
                    <pre style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
      {displayError(details)}
    </pre>
              </Styleddiv>
              </Row>
              </PortletBody>
              </PortletBody>
      </Modal.Body>
        
    </Modal>
  );
};

const Styleddiv = styled.div`
overflow-y:scroll;
max-height:500px;
`;

export default JobboardErrorModal;
